import React from 'react';
import { ESTADOS, ESTADO_COLORS } from './agendaConstants';
import './agendaCalendario.css';

const AgendaEstadoLeyenda = () => (
  <div className="agenda-estado-leyenda">
    {ESTADOS.map((estado) => (
      <span key={estado} className="agenda-estado-leyenda-item">
        <span
          className="agenda-estado-leyenda-dot"
          style={{ background: ESTADO_COLORS[estado] }}
          aria-hidden
        />
        {estado}
      </span>
    ))}
  </div>
);

export default AgendaEstadoLeyenda;
